import { atom } from 'jotai';
import { Basket } from '../../../models/basket.model';

const basketAtom = atom<Basket | null>(null);

export { basketAtom };
